// Estados de pedido según el tipo de negocio.
// Se consumen en el panel admin y en el panel del trabajador.
const ESTADOS = {
    comidas: ['Pendiente', 'En preparación', 'Listo', 'Entregado', 'Cancelado'],
    tienda: ['Pendiente', 'Enviado', 'Entregado', 'Cancelado'],
};

export function obtenerEstados(tipoNegocio) {
    return ESTADOS[tipoNegocio] || ESTADOS.comidas;
}

export default ESTADOS;
